import { LOCALE_DEVTOOL } from './types.js';
import { SET_LOCALE, SET_LOCALE_START, SET_LOCALE_SUCCESS, SET_LOCALE_ERROR, SET_LOCALE_DEVTOOL, UPDATE_NON_TRANSLATABLE_RESOURCE_STRINGS, SET_LOCALE_STATE, } from './constants.js';
export const intl = (state, action) => {
    if (!state) {
        // default state
        return {
            devtool: LOCALE_DEVTOOL.NONE,
            currentLocale: '',
            defaultLocale: '',
            requestedLocale: '',
            previousLocale: '',
            supported: [],
            messages: {},
            nonTranslatableResourceStrings: {},
        };
    }
    switch (action.type) {
        case SET_LOCALE_STATE: {
            const config = action.payload;
            return {
                devtool: LOCALE_DEVTOOL.NONE,
                currentLocale: config.source,
                defaultLocale: config.source,
                requestedLocale: config.default,
                previousLocale: config.source,
                supported: config.supported,
                messages: {},
                nonTranslatableResourceStrings: {},
            };
        }
        case SET_LOCALE: {
            const locale = action.payload.locale;
            return {
                ...state,
                currentLocale: locale,
                requestedLocale: locale,
                previousLocale: locale,
                messages: action.payload.messages,
            };
        }
        case SET_LOCALE_START: {
            const requestedLocale = action.payload;
            return {
                ...state,
                requestedLocale,
                previousLocale: state.currentLocale,
            };
        }
        case SET_LOCALE_SUCCESS: {
            return {
                ...state,
                currentLocale: action.payload.locale,
                messages: action.payload.messages,
            };
        }
        case SET_LOCALE_ERROR: {
            return {
                ...state,
                requestedLocale: state.previousLocale,
            };
        }
        case SET_LOCALE_DEVTOOL: {
            return {
                ...state,
                devtool: action.payload.devtool,
            };
        }
        case UPDATE_NON_TRANSLATABLE_RESOURCE_STRINGS: {
            return {
                ...state,
                nonTranslatableResourceStrings: {
                    ...state.nonTranslatableResourceStrings,
                    ...action.payload,
                },
            };
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=reducer.js.map